import Box from "@nodes/@material-ui/core/Box";
import Card from "@nodes/@material-ui/core/Card";
import Typography from "@nodes/@material-ui/core/Typography";
import { formatPhoneNumber, concatPhoneLink } from "../functions";

// <PhoneIcon /> <span>{formatPhoneNumber(loan.routePhone)}</span>

const RenderRouteDetailCredit = ({ loan = {} }) => {
  if (+loan.private === 1)
    return (
      <Card variant="outlined">
        <Box p={2}>
          <Typography variant="h6">Prestamista Privado!</Typography>
        </Box>
      </Card>
    );

  return (
    <Card variant="outlined">
      <ul className="list-group list-group-flush">
        <li className="list-group-item">
          <b>Ruta</b> {loan.route_name}
        </li>
        <li className="list-group-item">
          <b>Zona</b> {loan.location}
        </li>
        <li className="list-group-item">
          <b>Telefono</b> <a href={concatPhoneLink(loan.routePhone)}>{formatPhoneNumber(loan.routePhone)} </a>
          {loan.routePhone2 && (
            <span>
              {" "}
              | <a href={concatPhoneLink(loan.routePhone2)}>{formatPhoneNumber(loan.routePhone2)} </a>
            </span>
          )}
        </li>
      </ul>
    </Card>
  );
};

export default RenderRouteDetailCredit;
